import React, { useState, useEffect } from "react"
import { AppContext } from "../App"
import { StatisticsManager } from "../statisticsManager"
import Statistics from "./Statistics"
import strings from "../strings"
import { generateShareText, shareContent, isMobileDevice } from "../utils/shareUtils"

function GameOver() {
  const { gameOver, currAttempt, correctWord, board, boardStatus } = React.useContext(AppContext)
  const [showStatistics, setShowStatistics] = useState(false)
  const [showShareToast, setShowShareToast] = useState(false)
  
  // Get current date for display in Afrikaans
  const currentDate = new Date().toLocaleDateString('af-ZA', strings.dateFormat)

  // Record game completion in statistics when component mounts
  useEffect(() => {
    if (gameOver.gameOver) {
      // Get the guesses from localStorage or reconstruct from current state
      const currentGameState = JSON.parse(
        localStorage.getItem(`wordle-afrikaans-${new Date().toLocaleDateString('en-CA')}`) || '{}'
      )
      
      const guesses = currentGameState.guesses || []
      
      StatisticsManager.recordGameCompletion(
        gameOver.guessedWord,
        currAttempt.attempt,
        guesses
      )
    }
  }, [gameOver.gameOver, gameOver.guessedWord, currAttempt.attempt])

  const handleShowStatistics = () => {
    setShowStatistics(true)
  }

  const handleCloseStatistics = () => {
    setShowStatistics(false)
  }

  const handleShare = async () => {
    try {
      const shareText = generateShareText(
        board,
        boardStatus,
        currAttempt.attempt,
        gameOver.guessedWord
      )
      
      await shareContent(shareText)
      
      // Show toast only on desktop (mobile will show native share dialog)
      if (!isMobileDevice()) {
        setShowShareToast(true)
        setTimeout(() => setShowShareToast(false), 3000)
      }
    } catch (error) {
      console.error('Failed to share:', error)
    }
  }

  return (
    <>
      <div className="gameOver">
        <div className="game-completion-header">
          <h2>{strings.dailyWordelComplete}</h2>
          <p className="completion-date">{currentDate}</p>
        </div>
        
        <div className="game-result">
          {gameOver.guessedWord ? (
            <>
              <h3 className="success-message">{strings.congratulations}</h3>
              <p>{strings.solvedInAttempts(currAttempt.attempt)}</p>
            </>
          ) : (
            <>
              <h3 className="failure-message">{strings.betterLuckTomorrow}</h3>
              <p>{strings.youllGetNextOne}</p>
            </>
          )}
          
          <div className="correct-word-display">
            <h1>{strings.todaysWord} <span className="word-highlight">{correctWord}</span></h1>
          </div>
        </div>

        <div className="game-actions">
          <button 
            className="share-button"
            onClick={handleShare}
            aria-label="Deel jou resultaat"
          >
            Deel
          </button>
          
          <button 
            className="stats-button"
            onClick={handleShowStatistics}
            aria-label={strings.a11y.viewStatistics}
          >
            {strings.statistics}
          </button>
        </div>

        <div className="daily-game-info">
          <p className="next-game-info">
            {strings.comeBackTomorrow}
          </p>
          <p className="game-rules-reminder">
            {strings.dailyChallengeInfo}
          </p>
        </div>
      </div>

      <Statistics 
        isVisible={showStatistics}
        onClose={handleCloseStatistics}
      />
      
      {/* Share toast for desktop */}
      {showShareToast && (
        <div className="share-toast">
          In jou knipbord
        </div>
      )}
    </>
  )
}

export default GameOver
